class Products {
  constructor() {
    this.circle = document.querySelectorAll(".circle");
    this.events();
  }
  events() {
    this.displayCirclesIfViewportTallEnough();
  }
  displayCirclesIfViewportTallEnough() {
    window.addEventListener("load", () => {
      const height = document.body.clientHeight;
      console.log(height);
      if (height >= 5000 && this.circle) {
        this.circle.forEach((element) => {
          element.classList.remove("hidden");
        });
      }
    });
  }
}
export default Products;
